import { FC } from "react"
import classNames from "classnames"
import { Link } from "gatsby"

// icons
import { ChevronLeftIcon } from "@eventbrite/marmalade"

// utils
import { trackClick } from "./Breadcrumbs"

// styles
import * as styles from "./Breadcrumbs.module.scss"

export type Props = {
  url: string
  title: string
  nodeLocale: string
  handleClick?: React.MouseEventHandler<HTMLDivElement>
  className?: string
}

export const BackCrumb: FC<Props> = ({
  className,
  handleClick,
  url,
  nodeLocale,
  title = "Help Center"
}) => {
  const href = `/${nodeLocale.toLowerCase()}${url}`.replace(/\/+/g, "/")

  return (
    <div className={styles?.breadcrumbSection} onClick={handleClick}>
      <div
        className={classNames(
          styles.breadcrumbIconContainer,
          styles.leftChevronContainer,
          className
        )}
      >
        <ChevronLeftIcon size="medium" />
      </div>

      <Link
        to={href}
        onClick={() => trackClick("Help Center", window?.location?.pathname)}
      >
        {title}
      </Link>
    </div>
  )
}
